// src/components/LoadingSpinner/LoadingSpinner.tsx

import React from 'react';

interface LoadingSpinnerProps {
    size?: 'small' | 'medium' | 'large';
    text?: string | null;
}

const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({ size = 'medium', text = 'Loading...' }) => {
    const sizeClass = {
        small: 'w-6 h-6',
        medium: 'w-10 h-10',
        large: 'w-14 h-14'
    }[size];

    return (
        <div className="flex flex-col items-center justify-center p-4">
            <div className={`relative ${sizeClass}`}>
                <div className="absolute inset-0 border-[3px] border-transparent border-t-primary rounded-full animate-spin"></div>
            </div>
            {text && <div className="mt-2 text-sm text-muted-foreground">{text}</div>}
        </div>
    );
};

export default LoadingSpinner;
